import cookie from '../../../tools/cookie';
import { getQueryParamsMap } from '../../../tools/queryString';

export class MtLang {
    /**
     * Вычисляет текущий язык
     */
    public resolve() {
        const resolvedLanguage =
            // 1) query string
            getQueryParamsMap()['lang'] ||
            // 2) cookie
            cookie.get('lang') ||
            // 3) navigator
            this.getSystemLanguage();

        return resolvedLanguage;
    }

    /**
     * Получаем язык из навигатора
     */
    protected getSystemLanguage() {
        const navigator: {
            browserLanguage?: string;
            userLanguage?: string;
            systemLanguage?: string;
        } & Navigator = window.navigator;

        return this.normalize(
            navigator.language ||
                navigator.browserLanguage ||
                navigator.userLanguage ||
                navigator.systemLanguage
        );
    }

    /**
     * Приводит код языка к используемому в проекте виду
     *
     * @param {string} language
     */
    protected normalize(language?: string) {
        if (!language) {
            return language;
        }

        language = language.toLowerCase();

        // https://tools.ietf.org/html/rfc4646
        if (/-/.test(language)) {
            // код языка и страны разделяются дефисом
            return language.split('-')[0];
        } else if (/_/.test(language)) {
            // иногда есть "но"
            return language.split('_')[0];
        } else {
            // возможно, это код языка без кода страны
            return language;
        }
    }
}
